var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.to},nativeOn:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.icon)?_c('Icon',{staticClass:"icon",attrs:{"name":_vm.icon}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }